import React from 'react';
import LeagueTable from './LeagueTable.jsx';
import LeagueResults from './LeagueResults.jsx';

const LeagueWidgetsRow = ({stage}) =>
  <div className="row league-page-tables">
    <div className="template-item col-md-6">
      <LeagueTable stage={stage} />
    </div>
    <div className="template-item col-md-6">
      <LeagueResults stage={stage} />
    </div>
  </div>;

export default LeagueWidgetsRow;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/LeagueWidgetsRow.jsx